import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Box } from '@mui/material';
import { LineChart, Line, AreaChart, Area, ResponsiveContainer, XAxis, CartesianGrid, BarChart, Bar, Cell, Tooltip } from 'recharts';

import MonitorHeartOutlinedIcon from '@mui/icons-material/MonitorHeartOutlined';
import TrendingUpOutlinedIcon from '@mui/icons-material/TrendingUpOutlined';
import TrendingDownOutlinedIcon from '@mui/icons-material/TrendingDownOutlined';
import ShieldOutlinedIcon from '@mui/icons-material/ShieldOutlined';
import ArrowDownwardOutlinedIcon from '@mui/icons-material/ArrowDownwardOutlined';
import ReportGmailerrorredOutlinedIcon from '@mui/icons-material/ReportGmailerrorredOutlined';
import AdsClickOutlinedIcon from '@mui/icons-material/AdsClickOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined';
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';
import HistoryIcon from '@mui/icons-material/History';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import PieChartOutlineIcon from '@mui/icons-material/PieChartOutline';
import ChevronRightOutlinedIcon from '@mui/icons-material/ChevronRightOutlined';

const AIHealthDrift = () => {
    const navigate = useNavigate();

    const smartPricingData = [{ v: 20 }, { v: 25 }, { v: 22 }, { v: 30 }, { v: 28 }, { v: 35 }, { v: 32 }, { v: 40 }];
    const payoutData = [{ v: 40 }, { v: 38 }, { v: 42 }, { v: 35 }, { v: 38 }, { v: 45 }, { v: 42 }, { v: 48 }];
    const productRecData = [{ v: 30 }, { v: 35 }, { v: 45 }, { v: 40 }, { v: 48 }, { v: 35 }, { v: 30 }, { v: 25 }];
    const vendorData = [{ v: 25 }, { v: 30 }, { v: 28 }, { v: 35 }, { v: 32 }, { v: 40 }, { v: 38 }, { v: 45 }];
    const overrideTrendData = [
        { time: '11:00', v: 90 }, { time: '12:00', v: 75 }, { time: '13:00', v: 70 }, { time: '14:00', v: 65 },
        { time: '15:00', v: 62 }, { time: '16:00', v: 55 }, { time: '17:00', v: 50 }, { time: '18:00', v: 48 },
        { time: '19:00', v: 45 }, { time: '20:00', v: 42 }, { time: '21:00', v: 40 }, { time: '22:00', v: 35 },
        { time: '23:00', v: 38 }, { time: '00:00', v: 45 }
    ];
    const smallOverrideTrend = [{ v: 10 }, { v: 15 }, { v: 8 }, { v: 12 }, { v: 20 }, { v: 15 }, { v: 25 }];
    const driftTrendData = [
        { time: '22 17:31', v: 15 },
        { time: '15:270', v: 28 },
        { time: '113:30', v: 40 },
        { time: '17:400', v: 45 },
        { time: '17:34', v: 38 },
        { time: '40:700', v: 60 },
        { time: '60:402', v: 75 },
        { time: '12:002', v: 72 },
    ];
    const rightDriftData = [
        { name: 'AI/ML', v: 40, fill: '#8ea6c8' },
        { name: '...', v: 38, fill: '#8ea6c8' },
        { name: '...', v: 38, fill: '#8ea6c8' },
        { name: 'STUDEN', v: 20, fill: '#d1c8c1' },
        { name: '...', v: 25, fill: '#e6a456' },
        { name: '1,2 CORE', v: 35, fill: '#e6a456' },
        { name: '...', v: 28, fill: '#e6a456' },
        { name: 'TLADRS', v: 22, fill: '#e6a456' },
        { name: '...', v: 45, fill: '#e6a456' },
        { name: 'FIEXEP', v: 35, fill: '#e6a456' },
        { name: '...', v: 28, fill: '#eadecd' },
        { name: 'T DIDSS', v: 25, fill: '#eadecd' },
        { name: '...', v: 22, fill: '#eadecd' },
        { name: '...', v: 10, fill: '#eadecd' },
        { name: '...', v: 5, fill: '#eadecd' },
        { name: '...', v: 2, fill: '#eadecd' },
    ];
    const confidenceStabilityData = [
        { time: '1', v: 80 }, { time: '2', v: 82 }, { time: '3', v: 75 }, { time: '4', v: 70 },
        { time: '5', v: 65 }, { time: '6', v: 60 }, { time: '7', v: 58 }, { time: '8', v: 62 },
        { time: '9', v: 55 }, { time: '10', v: 52 }, { time: '11', v: 50 }, { time: '12', v: 48 },
        { time: '13', v: 45 }, { time: '14', v: 42 }, { time: '15', v: 40 }, { time: '16', v: 38 },
        { time: '17', v: 35 }, { time: '18', v: 32 }
    ];

    return (
        <>
            <div className="main_title">
                <h1>AI Health, Drift & Quality Monitoring</h1>
                <p>
                    <button onClick={() => navigate("/dashboard")}>Dashboard</button> - AI Health, Drift & Quality Monitoring
                </p>
            </div>
            <div className="stats_boxes gap_m mb_20">
                {/* CARD 1 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            88
                            <p>AI Health Score</p>
                        </h2>
                        <figure className="sucess">
                            <MonitorHeartOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight">
                        <div>
                            <CheckCircleOutlineIcon fontSize="small" /> <span>Summary</span>
                        </div>
                        <div>
                            <Box component="span" className="badge_health" sx={{ background: '#e6ffed', color: '#2da44e', padding: '2px 8px', borderRadius: '4px', fontSize: '11px', fontWeight: 600 }}>Healthy</Box>
                        </div>
                    </div>
                </div>

                {/* CARD 2 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            92.4%
                            <p>Uptime</p>
                        </h2>
                        <Box component="figure" className="sucess" sx={{ color: '#0da3a1', background: '#e0f2f1' }}>
                            <TrendingUpOutlinedIcon fontSize="large" />
                        </Box>
                    </div>
                    <div className="ai_insight positive">
                        <div>
                            <TrendingUpOutlinedIcon fontSize="small" /> <span>70.X% &gt; 74%</span>
                        </div>
                        <div>
                            <AccessTimeOutlinedIcon fontSize="small" /> <span>Last 7 Days: 7</span>
                        </div>
                    </div>
                </div>

                {/* CARD 3 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            14.6%
                            <p>Moderate Risk</p>
                        </h2>
                        <figure className="warning">
                            <ShieldOutlinedIcon fontSize="large" />
                        </figure>
                    </div>
                    <div className="ai_insight negative">
                        <div>
                            <WarningAmberOutlinedIcon fontSize="small" /> <span>Moderate 11.2%</span>
                        </div>
                        <div>
                            <TrendingDownOutlinedIcon fontSize="small" /> <span>Decline</span>
                        </div>
                    </div>
                </div>

                {/* CARD 4 */}
                <div className="cards">
                    <div className="data_top">
                        <h2>
                            7%
                            <p>Drop</p>
                        </h2>
                        <Box component="figure" className="warning" sx={{ color: '#888', background: '#f5f5f5' }}>
                            <ArrowDownwardOutlinedIcon fontSize="large" />
                        </Box>
                    </div>
                    <div className="ai_insight text_muted">
                        <div>
                            <ArrowDownwardOutlinedIcon fontSize="small" /> <span>Drop in last 7 days</span>
                        </div>
                        <div>
                            <HistoryIcon fontSize="small" /> <span>History</span>
                        </div>
                    </div>
                </div>

                {/* <div className="cards">
                    <div className="data_top">
                        <h2>
                            23%
                            <p>Medium Issue</p>
                        </h2>
                        <Box component="figure" className="error" sx={{ color: '#f04e3e', bgcolor: '#fdf2f2' }}>
                            <ReportGmailerrorredOutlinedIcon fontSize="large" />
                        </Box>
                    </div>
                    <div className="ai_insight negative">
                        <div>
                            <WarningAmberOutlinedIcon fontSize="small" /> <span>Medium</span>
                        </div>
                        <div>
                            <InfoOutlinedIcon fontSize="small" /> <span>Redo 10 (14:45)</span>
                        </div>
                    </div>
                </div>

                <div className="cards">
                    <div className="data_top">
                        <h2>
                            23%
                            <p>Medium</p>
                        </h2>
                        <Box component="figure" className="warning" sx={{ color: '#d97706', background: '#fef3c7' }}>
                            <AdsClickOutlinedIcon fontSize="large" />
                        </Box>
                    </div>
                    <div className="ai_insight negative">
                        <div>
                            <WarningAmberOutlinedIcon fontSize="small" /> <span>10 moderate ✔ 3 dys</span>
                        </div>
                        <div>
                            <Button size="small" variant="contained" sx={{ textTransform: 'none', background: '#fdf5eb', color: '#c07c39', boxShadow: 'none', minWidth: 'auto', padding: '2px 8px', fontSize: '11px', whiteSpace: 'nowrap', '&:hover': { background: '#fcebdb' } }}>Freeze Model</Button>
                        </div>
                    </div>
                </div> */}
            </div>
            <div className="table_flex">
                <div className="lt">
                    <div className="cards table_card">
                        <div className="table_header">
                            <div className="left_s">
                                <h3>Model Performance</h3>
                            </div>
                        </div>
                        <TableContainer className="table_container">
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>AI Feature <TrendingUpOutlinedIcon sx={{ fontSize: 14, color: '#ccc', ml: 0.5, verticalAlign: 'middle' }} /></TableCell>
                                        <TableCell>Accuracy %</TableCell>
                                        <TableCell>Override %</TableCell>
                                        <TableCell>Confidence %</TableCell>
                                        <TableCell>Trend</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow hover>
                                        <TableCell><Box display="flex" alignItems="center" gap={1}><Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#ccc', display: 'inline-block' }}></Box> Smart Pricing</Box></TableCell>
                                        <TableCell><b>89%</b></TableCell>
                                        <TableCell>12.2% <TrendingUpOutlinedIcon className="text_danger" sx={{ fontSize: 16, verticalAlign: 'middle' }} /></TableCell>
                                        <TableCell><b>86%</b></TableCell>
                                        <TableCell>
                                            <Box width={100} height={30}>
                                                <ResponsiveContainer width="100%" height="100%">
                                                    <LineChart data={smartPricingData}>
                                                        <Line type="monotone" dataKey="v" stroke="#0da3a1" strokeWidth={2} dot={false} />
                                                    </LineChart>
                                                </ResponsiveContainer>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow hover>
                                        <TableCell><Box display="flex" alignItems="center" gap={1}><Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#ccc', display: 'inline-block' }}></Box> Payout Optimization</Box></TableCell>
                                        <TableCell><b>91%</b></TableCell>
                                        <TableCell>14.6% <TrendingUpOutlinedIcon className="text_danger" sx={{ fontSize: 16, verticalAlign: 'middle' }} /></TableCell>
                                        <TableCell><b>90%</b></TableCell>
                                        <TableCell>
                                            <Box width={100} height={30}>
                                                <ResponsiveContainer width="100%" height="100%">
                                                    <LineChart data={payoutData}>
                                                        <Line type="monotone" dataKey="v" stroke="#f5b041" strokeWidth={2} dot={false} />
                                                    </LineChart>
                                                </ResponsiveContainer>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow hover>
                                        <TableCell><Box display="flex" alignItems="center" gap={1}><Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#ccc', display: 'inline-block' }}></Box> Product Recommendations</Box></TableCell>
                                        <TableCell><b>88%</b></TableCell>
                                        <TableCell>18.7% <TrendingUpOutlinedIcon className="text_success" sx={{ fontSize: 16, verticalAlign: 'middle' }} /></TableCell>
                                        <TableCell><b>83%</b> <Box component="span" className="text_danger">Decline</Box></TableCell>
                                        <TableCell>
                                            <Box width={100} height={30}>
                                                <ResponsiveContainer width="100%" height="100%">
                                                    <AreaChart data={productRecData}>
                                                        <Area type="monotone" dataKey="v" stroke="#f04e3e" fill="#fdf2f2" strokeWidth={2} />
                                                    </AreaChart>
                                                </ResponsiveContainer>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                    <TableRow hover>
                                        <TableCell><Box display="flex" alignItems="center" gap={1}><Box component="span" sx={{ width: 6, height: 6, borderRadius: '50%', bgcolor: '#ccc', display: 'inline-block' }}></Box> Vendor Onboarding</Box></TableCell>
                                        <TableCell><b>95%</b></TableCell>
                                        <TableCell>7.5% <TrendingUpOutlinedIcon className="text_success" sx={{ fontSize: 16, verticalAlign: 'middle' }} /></TableCell>
                                        <TableCell><b>95%</b></TableCell>
                                        <TableCell>
                                            <Box width={100} height={30}>
                                                <ResponsiveContainer width="100%" height="100%">
                                                    <LineChart data={vendorData}>
                                                        <Line type="monotone" dataKey="v" stroke="#888" strokeWidth={2} dot={false} />
                                                    </LineChart>
                                                </ResponsiveContainer>
                                            </Box>
                                        </TableCell>
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>

                    {/* <div className="cards mt_20">
                        <div className="table_header">
                            <div className="left_s">
                                <h3>Model Drift Detection</h3>
                            </div>
                            <div className="right_s">
                                <Button size="small" endIcon={<KeyboardArrowDownIcon />} sx={{ color: '#666', textTransform: 'none' }}>Last 30 Days</Button>
                                <Button size="small" variant="contained" startIcon={<LockOutlinedIcon />} sx={{ textTransform: 'none', background: '#fdf5eb', color: '#c07c39', boxShadow: 'none', '&:hover': { background: '#fcebdb' } }}>
                                    Freeze Model
                                </Button>
                            </div>
                        </div>

                        <Box display="flex" flexWrap="wrap" gap={3}>
                            <Box flex={1} minWidth={{ xs: '100%', md: '250px' }}>
                                <Box display="flex" justifyContent="space-between" alignItems="center" mb={1} borderBottom="1px solid #eee" pb={1}>
                                    <Box component="span" sx={{ fontSize: '13px', fontWeight: 600, color: '#555' }}>Recent Drift</Box>
                                    <Box display="flex" gap={1}>
                                        <TrendingUpOutlinedIcon sx={{ fontSize: 18, color: '#999' }} />
                                        <HistoryIcon sx={{ fontSize: 18, color: '#1976d2' }} />
                                    </Box>
                                </Box>
                                <Table size="small" sx={{ '& td': { borderBottom: 'none', py: 1, px: 0 } }}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell><Box display="flex" alignItems="center" gap={1}><Box component="span" sx={{ width: 6, height: 6, bgcolor: '#ccc', display: 'inline-block' }}></Box> Block Vendor</Box></TableCell>
                                            <TableCell align="right"><b>21%</b> <Box component="span" className="text_danger" sx={{ fontSize: '11px', ml: '5px' }}>spiked</Box></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><Box display="flex" alignItems="center" gap={1}><Box component="span" sx={{ width: 6, height: 6, bgcolor: '#ccc', display: 'inline-block' }}></Box> Dispute Decision</Box></TableCell>
                                            <TableCell align="right"><b>19%</b></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><Box display="flex" alignItems="center" gap={1}><Box component="span" sx={{ width: 6, height: 6, bgcolor: '#ccc', display: 'inline-block' }}></Box> Price Change</Box></TableCell>
                                            <TableCell align="right"><b>15%</b></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Box>

                            <Box flex={{ xs: 1, md: 0.8 }} minWidth="200px" sx={{ borderLeft: { md: '1px solid #eee' }, borderRight: { md: '1px solid #eee' }, px: { md: 3 }, py: { xs: 2, md: 0 } }}>
                                <Box mb={1} borderBottom="1px solid #eee" pb={1}>
                                    <Box component="span" sx={{ fontSize: '13px', fontWeight: 600, color: '#555' }}>Last 7 Days</Box>
                                </Box>
                                <Box sx={{ fontSize: '12px', color: '#555', mb: 2 }}>
                                    Total Alert <Box component="span" sx={{ fontWeight: 600 }}>&gt; 4x &uarr;</Box>
                                </Box>
                                <Box display="flex" flexDirection="column" gap={1}>
                                    <Box display="flex" alignItems="center" gap={1} sx={{ fontSize: '12px' }}>
                                        <Box component="span" sx={{ width: 10, height: 10, bgcolor: '#f5b041', display: 'inline-block', borderRadius: '2px' }}></Box> High
                                    </Box>
                                    <Box display="flex" alignItems="center" gap={1} sx={{ fontSize: '12px' }}>
                                        <Box component="span" sx={{ width: 10, height: 10, border: '1px solid #ccc', display: 'inline-block', borderRadius: '2px' }}></Box> Critical <b>78%</b>
                                    </Box>
                                    <Box display="flex" alignItems="center" gap={1} sx={{ fontSize: '12px' }}>
                                        <Box component="span" sx={{ width: 10, height: 10, border: '1px solid #ccc', display: 'inline-block', borderRadius: '50%' }}></Box> Avg <b>5468</b>
                                    </Box>
                                </Box>
                            </Box>

                            <Box flex={2} minWidth="300px">
                                <Box mb={1} borderBottom="1px solid #eee" pb={1}>
                                    <Box component="span" sx={{ fontSize: '13px', fontWeight: 600, color: '#555' }}>Trend</Box>
                                </Box>
                                <Box width="100%" height={120}>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <AreaChart data={driftTrendData} margin={{ top: 5, right: 0, left: 0, bottom: 0 }}>
                                            <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f5f5f5" />
                                            <XAxis dataKey="time" axisLine={false} tickLine={false} tick={{ fontSize: 10, fill: '#999' }} dy={10} />
                                            <Area type="monotone" dataKey="v" stroke="#f5b041" fill="#fdf5eb" strokeWidth={2} />
                                        </AreaChart>
                                    </ResponsiveContainer>
                                </Box>
                            </Box>
                        </Box>
                    </div>
                    <div className="cards mt_20">
                        <div className="table_header">
                            <div className="left_s">
                                <h3>Override Monitoring</h3>
                            </div>
                            <div className="right_s">
                                <Button size="small" endIcon={<KeyboardArrowDownIcon />} sx={{ color: '#666', textTransform: 'none' }}>Last 30 Days</Button>
                                <Button size="small" variant="contained" sx={{ textTransform: 'none', background: '#f5f5f5', color: '#666', boxShadow: 'none', padding: '2px 8px', minWidth: 'auto', '&:hover': { background: '#eee' } }}>
                                    Late
                                </Button>
                            </div>
                        </div>

                        <Box display="flex" flexWrap="wrap" sx={{ borderTop: '1px solid #eee', pt: 2 }}>
                            <Box flex={{ xs: '100%', md: '0 0 30%' }} pr={{ md: 3 }} borderRight={{ md: '1px solid #eee' }} mb={{ xs: 3, md: 0 }}>
                                <Box display="flex" alignItems="baseline" gap={1} mb={2}>
                                    <Box component="span" sx={{ fontSize: '24px', fontWeight: 600 }}>637</Box>
                                    <Box component="span" sx={{ fontSize: '12px', color: '#555' }}>Overrides</Box>
                                    <TrendingDownOutlinedIcon sx={{ fontSize: 16, color: '#ccc', ml: 'auto' }} /> <Box component="span" sx={{ fontSize: '12px', color: '#999' }}>Last 7 Days</Box> <ArrowDownwardOutlinedIcon sx={{ fontSize: 14, color: '#ccc' }} />
                                </Box>

                                <Table size="small" sx={{ '& td': { borderBottom: 'none', py: 1.5, px: 0 } }}>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell><Box display="flex" alignItems="center" gap={1}><Box component="span" sx={{ width: 6, height: 6, bgcolor: '#ccc', display: 'inline-block' }}></Box> Block Vendor</Box></TableCell>
                                            <TableCell align="right"><b>21%</b> <Box component="span" className="text_danger" sx={{ fontSize: '11px', ml: '5px', background: '#fdf2f2', padding: '2px 6px', borderRadius: '4px' }}>spiked</Box></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><Box display="flex" alignItems="center" gap={1}><Box component="span" sx={{ width: 6, height: 6, bgcolor: '#ccc', display: 'inline-block' }}></Box> Dispute Decision</Box></TableCell>
                                            <TableCell align="right"><b>19%</b></TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell><Box display="flex" alignItems="center" gap={1}><Box component="span" sx={{ width: 6, height: 6, bgcolor: '#ccc', display: 'inline-block' }}></Box> Price Change</Box></TableCell>
                                            <TableCell align="right"><b>15%</b></TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </Box>

                            <Box flex={{ xs: '100%', md: '1' }} pl={{ md: 3 }} display="flex" flexDirection="column">
                                <Box display="flex" gap={2} alignItems="flex-start" flex={1}>
                                    <Box flex={1} height={120} borderLeft="1px solid #eee" borderBottom="1px solid #eee">
                                        <ResponsiveContainer width="100%" height="100%">
                                            <LineChart data={overrideTrendData} margin={{ top: 10, right: 10, left: 0, bottom: 0 }}>
                                                <CartesianGrid strokeDasharray="3 3" vertical={true} horizontal={true} stroke="#f5f5f5" />
                                                <XAxis dataKey="time" axisLine={false} tickLine={false} tick={{ fontSize: 10, fill: '#999' }} dy={10} minTickGap={20} />
                                                <Line type="monotone" dataKey="v" stroke="#f5b041" strokeWidth={2} dot={{ r: 2, fill: '#f5b041' }} />
                                            </LineChart>
                                        </ResponsiveContainer>
                                    </Box>
                                    <Box width="100px" display="flex" flexDirection="column" justifyContent="space-between" height={100}>
                                        <Box>
                                            <Box display="flex" alignItems="center" gap={0.5}>
                                                <Box component="span" sx={{ fontSize: '18px', fontWeight: 600 }}>69%</Box>
                                                <TrendingDownOutlinedIcon sx={{ fontSize: 16, color: '#f5b041' }} />
                                                <Box component="span" sx={{ fontSize: '12px', color: '#f5b041' }}>7 ovr/dp</Box>
                                            </Box>
                                            <Box component="span" sx={{ fontSize: '11px', color: '#999' }}>Trend</Box>
                                        </Box>
                                        <Box display="flex" alignItems="center" gap={0.5}>
                                            <TrendingDownOutlinedIcon sx={{ fontSize: 16, color: '#f5b041' }} />
                                            <Box component="span" sx={{ fontSize: '12px', color: '#666', fontWeight: 500 }}>9% Drop Alert</Box>
                                        </Box>
                                    </Box>
                                </Box>

                                <Box display="flex" justifyContent="space-between" alignItems="center" mt={3} pt={2} borderTop="1px solid #eee" flexWrap="wrap" gap={2}>
                                    <Box display="flex" alignItems="center" gap={2}>
                                        <Box component="span" sx={{ fontSize: '13px', color: '#555' }}>637 Overrides in <Box component="span" sx={{ color: '#999' }}>last 7 Days</Box></Box>
                                        <Box width={60} height={20}>
                                            <ResponsiveContainer width="100%" height="100%">
                                                <LineChart data={smallOverrideTrend}>
                                                    <Line type="monotone" dataKey="v" stroke="#666" strokeWidth={1.5} dot={false} />
                                                </LineChart>
                                            </ResponsiveContainer>
                                        </Box>
                                    </Box>

                                    <Box display="flex" alignItems="center" gap={2} bgcolor="#fdf5eb" px={2} py={1} borderRadius={1}>
                                        <AdsClickOutlinedIcon sx={{ fontSize: 18, color: '#555' }} />
                                        <Box component="span" sx={{ fontSize: '13px', color: '#555', fontWeight: 500 }}>Trigger <Box component="span" sx={{ fontWeight: 600 }}>Evaluation</Box></Box>
                                        <Box component="span" sx={{ bgcolor: '#fff', px: 1, py: 0.5, borderRadius: 1, fontSize: '12px', fontWeight: 600, color: '#555', ml: 2, boxShadow: '0 1px 2px rgba(0,0,0,0.05)' }}>55</Box>
                                    </Box>
                                </Box>
                            </Box>
                        </Box>
                    </div> */}

                </div>
                {/* <div className="rt">
                    <div className="cards table_card">
                        <div className="table_header">
                            <div className="left_s">
                                <h3>Model Drift Detection</h3>
                            </div>
                        </div>

                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Box component="span" sx={{ fontSize: '13px', color: '#555' }}>Last 7 Days</Box>
                            <Button size="small" variant="text" startIcon={<LockOutlinedIcon />} sx={{ textTransform: 'none', color: '#555' }}>
                                Freeze Model
                            </Button>
                        </Box>

                        <Box height={100} mb={3}>
                            <ResponsiveContainer width="100%" height="100%">
                                <BarChart data={rightDriftData} margin={{ top: 0, right: 0, left: 0, bottom: 0 }} barCategoryGap={1}>
                                    <CartesianGrid strokeDasharray="3 3" vertical={false} stroke="#f5f5f5" />
                                    <XAxis dataKey="name" axisLine={false} tickLine={false} tick={{ fontSize: 9, fill: '#999' }} dy={5} interval={0} />
                                    <Tooltip cursor={{ fill: '#f5f5f5' }} />
                                    <Bar dataKey="v" radius={[2, 2, 0, 0]}>
                                        {rightDriftData.map((entry, index) => (
                                            <Cell key={`cell-${index}`} fill={entry.fill || '#ccc'} />
                                        ))}
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                        </Box>

                        <Box display="flex" alignItems="center" gap={1} mb={3} p={1.5} sx={{ bgcolor: '#fafafa', borderRadius: 1 }}>
                            <PieChartOutlineIcon sx={{ fontSize: 18, color: '#d9534f' }} />
                            <Box component="span" sx={{ fontSize: '13px', fontWeight: 600, color: '#555' }}>67 <Box component="span" sx={{ fontWeight: 400 }}>Moderate</Box></Box>

                            <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
                                <Box component="span" sx={{ fontSize: '12px', color: '#666' }}>Drop:</Box>
                                <Box width={40} height={20}>
                                    <ResponsiveContainer width="100%" height="100%">
                                        <LineChart data={smallOverrideTrend}>
                                            <Line type="monotone" dataKey="v" stroke="#f5b041" strokeWidth={1.5} dot={false} />
                                        </LineChart>
                                    </ResponsiveContainer>
                                </Box>
                                <TrendingDownOutlinedIcon sx={{ fontSize: 16, color: '#666' }} />
                            </Box>
                        </Box>

                        <Box display="flex" justifyContent="space-between" alignItems="center">
                            <Button size="small" variant="text" startIcon={<InfoOutlinedIcon />} endIcon={<ChevronRightOutlinedIcon />} sx={{ fontSize: '12px', textTransform: 'none', color: '#555', p: 0 }}>
                                History Statistics
                            </Button>
                            <Button size="small" variant="contained" sx={{ textTransform: 'none', background: '#f8f8f8', color: '#555', border: '1px solid #eee', boxShadow: 'none', '&:hover': { background: '#f0f0f0' } }}>
                                Trigger Retraining
                            </Button>
                        </Box>
                    </div>
                    <div className="cards mt_20">
                        <div className="table_header" style={{ marginBottom: '15px' }}>
                            <div className="left_s">
                                <h3>Confidence Stability</h3>
                            </div>
                        </div>

                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Box component="span" sx={{ fontSize: '13px', color: '#555' }}>Avg. 7 Days</Box>
                                <Box display="flex" alignItems="center" bgcolor="#f5f5f5" px={1} py={0.5} borderRadius={1} gap={0.5} sx={{ cursor: 'pointer' }}>
                                    <Box component="span" sx={{ fontSize: '12px', fontWeight: 600, color: '#333' }}>24%</Box>
                                    <TrendingDownOutlinedIcon sx={{ fontSize: 14, color: '#d9534f' }} />
                                    <KeyboardArrowDownIcon sx={{ fontSize: 14, color: '#666' }} />
                                </Box>
                            </Box>
                            <Button size="small" variant="contained" sx={{ textTransform: 'none', background: '#f8f8f8', color: '#555', border: '1px solid #eee', boxShadow: 'none', '&:hover': { background: '#f0f0f0' } }}>
                                Escalate Issue
                            </Button>
                        </Box>

                        <Box display="flex" alignItems="center" mt={3} position="relative" height={100} mb={1}>
                            <Box flex={1} height="100%">
                                <ResponsiveContainer width="100%" height="100%">
                                    <AreaChart data={confidenceStabilityData} margin={{ top: 10, right: 0, left: 0, bottom: 0 }}>
                                        <CartesianGrid strokeDasharray="3 3" vertical={true} horizontal={true} stroke="#f5f5f5" />
                                        <Area type="monotone" dataKey="v" stroke="#f5b041" fill="#fdf5eb" strokeWidth={1.5} dot={{ r: 1.5, fill: '#f5b041' }} />
                                    </AreaChart>
                                </ResponsiveContainer>
                            </Box>
                            <Box position="absolute" right={0} top={20} display="flex" alignItems="center" gap={0.5} bgcolor="rgba(255,255,255,0.9)" px={0.5} py={0.25}>
                                <TrendingDownOutlinedIcon sx={{ fontSize: 14, color: '#f5b041' }} />
                                <Box component="span" sx={{ fontSize: '11px', color: '#666', fontWeight: 500 }}>7% Drop Alert</Box>
                            </Box>
                        </Box>

                        <Box display="flex" justifyContent="space-between" alignItems="center" py={1.5} borderBottom="1px solid #eee" borderTop="1px solid #eee">
                            <Box display="flex" alignItems="center" gap={1}>
                                <Box component="span" sx={{ fontSize: '11px', color: '#666' }}>Last 14 Days</Box>
                                <Box component="span" sx={{ fontSize: '11px', color: '#999' }}>*Wkly. Avg</Box>
                            </Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Box borderLeft="1px solid #eee" pl={1}>
                                    <Box component="span" sx={{ fontSize: '11px', color: '#666' }}>06 Jun</Box>
                                </Box>
                                <Box component="span" sx={{ fontSize: '11px', color: '#ccc' }}>06 - 1R in/sec (47)</Box>
                            </Box>
                        </Box>

                        <Box display="flex" justifyContent="space-between" alignItems="center" mt={2}>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Box component="span" sx={{ fontSize: '13px', fontWeight: 600 }}>G 337</Box>
                                <Box component="span" sx={{ fontSize: '12px', color: '#666' }}>Overrides</Box>
                            </Box>
                            <h3 style={{ fontSize: '14px', fontWeight: 600, color: '#444' }}>Bias / Fairness Review</h3>
                        </Box>
                    </div>

                    <Box>
                        <Box display="flex" justifyContent="space-between" alignItems="center" py={1.5} borderTop="1px solid #f0f0f0" borderBottom="1px solid #f0f0f0">
                            <Box component="span" sx={{ fontSize: '12px', color: '#666' }}>Bias Detection Level:</Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Box component="span" sx={{ fontSize: '13px', fontWeight: 500, color: '#555' }}>Medium</Box>
                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <Box component="span" sx={{ width: 2, height: 10, bgcolor: '#ccc', display: 'inline-block' }}></Box>
                                    <Box component="span" sx={{ width: 2, height: 10, bgcolor: '#f5b041', display: 'inline-block' }}></Box>
                                    <Box component="span" sx={{ width: 2, height: 10, bgcolor: '#ccc', display: 'inline-block' }}></Box>
                                </Box>
                                <ChevronRightOutlinedIcon sx={{ fontSize: 16, color: '#ccc' }} />
                            </Box>
                        </Box>

                        <Box display="flex" justifyContent="space-between" alignItems="center" py={1.5} borderBottom="1px solid #f0f0f0">
                            <Box component="span" sx={{ fontSize: '12px', color: '#666' }}>Segment Disparity</Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Box component="span" sx={{ fontSize: '12px', fontWeight: 500, color: '#555' }}>10.3% •</Box>
                                <Box component="span" sx={{ fontSize: '12px', color: '#666' }}>Shopper App Seg</Box>
                            </Box>
                        </Box>

                        <Box display="flex" justifyContent="space-between" alignItems="center" py={1.5} borderBottom="1px solid #f0f0f0">
                            <Box component="span" sx={{ fontSize: '12px', color: '#666' }}>Potential Bias Deviation:</Box>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Box component="span" sx={{ fontSize: '12px', color: '#999' }}>1.4%</Box>
                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <Box component="span" sx={{ display: 'inline-block', width: 0, height: 0, borderLeft: '4px solid transparent', borderRight: '4px solid transparent', borderBottom: '6px solid #ccc' }}></Box>
                                    <Box component="span" sx={{ fontSize: '13px', fontWeight: 500, color: '#555' }}>Low</Box>
                                </Box>
                                <Box display="flex" alignItems="center" gap={0.5}>
                                    <Box component="span" sx={{ fontSize: '16px', color: '#ccc', fontFamily: 'monospace', letterSpacing: '-2px' }}>&lt;/&gt;</Box>
                                    <Box component="span" sx={{ fontSize: '12px', color: '#999' }}>Rx</Box>
                                </Box>
                                <ChevronRightOutlinedIcon sx={{ fontSize: 16, color: '#ccc' }} />
                            </Box>
                        </Box>

                        <Box display="flex" justifyContent="space-between" alignItems="center" mt={3}>
                            <Button size="small" variant="outlined" startIcon={<HistoryIcon sx={{ fontSize: 16 }} />} sx={{ textTransform: 'none', color: '#666', borderColor: '#ddd', p: '4px 12px', fontSize: '12px', '&:hover': { borderColor: '#ccc', backgroundColor: '#f9f9f9' } }}>
                                Set version Diff
                            </Button>
                            <Button size="small" variant="contained" sx={{ textTransform: 'none', background: '#a0855b', color: '#fff', boxShadow: 'none', p: '4px 16px', fontSize: '12px', '&:hover': { background: '#8d754e' } }}>
                                Generate Report
                            </Button>
                        </Box>
                    </Box>
                </div> */}
            </div>
        </>
    );
};

export default AIHealthDrift;
